import { render, staticRenderFns } from "./BabyBauchView.vue?vue&type=template&id=54282b90"
import script from "./BabyBauchView.vue?vue&type=script&lang=js"
export * from "./BabyBauchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports